import { getFlag } from '@mentimeter/flags/confidence/client';

export const useMobileIntentOnboardingRollout = (
  shouldResolve: boolean,
): boolean => {
  if (!shouldResolve) {
    return false;
  }

  // Fetch the flag value
  const { value: rolloutValue } = getFlag(
    'nux-mobile-intent-onboarding.enabled',
    false,
  );

  return rolloutValue; // Resolve with the flag value
};
